import { render } from "./EmergencyOutHoursDetails.vue?vue&type=template&id=4c746470&scoped=true&ts=true"
import script from "./EmergencyOutHoursDetails.vue?vue&type=script&lang=ts"
export * from "./EmergencyOutHoursDetails.vue?vue&type=script&lang=ts"

import "./EmergencyOutHoursDetails.vue?vue&type=style&index=0&id=4c746470&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c746470"]])

export default __exports__